































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import AgencyUser from "@/store/entities/user";
import Agency from "@/store/entities/agency";
@Component({})
export default class UserAddModal extends Vue {
  @Prop() public modalOpenType!: number;
  @Prop() public selectedUser!: any;
  dialog: boolean = true;
  agencyUser: AgencyUser = new AgencyUser();
  agency: Agency = new Agency();
  agencies: Agency[] = [];

  passport: Date = null;
  birthday: Date = null;
  rule: any[] = [(v) => !!v || "Bu Alan Zorunludur!"];
  emailRules: any[] = [
    (v) =>
      !v ||
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "E-mail must be valid",
  ];

  async createUser() {
    this.agencyUser.isActive = true;
    if ((this.$refs.UserForm as any).validate()) {
      // await this.$store.dispatch({
      //   type: "agency/getAgency",
      //   data: "",
      // });

        this.agencyUser.agencyId=this.agency.id;
        this.agencyUser.userName=this.agencyUser.emailAddress;
      let response = await this.$store.dispatch({
        type: "agencyUser/createUser",
        data: this.agencyUser,
      });
      if (response.success) {
        Vue.$toast.success("Kullanıcı başarılı bir şekilde eklendi");
        (this.$refs.UserForm as any).reset();
        this.closeDialog();
      } else {
        Vue.$toast.error("Bir sorun oluştu");
      }
    } else {
      this.$swal({
        icon: "error",
        title: "",
        text: "Lütfen zorunlu alanları doldurunuz",
        confirmButtonText: "Tamam",
        showConfirmButton: false,
      });
    }
  }
  async updateUser() {
    this.agencyUser.isActive = true;
    if ((this.$refs.UserForm as any).validate()) {
      
      this.agencyUser.agencyId=this.agency.id;
      let response = await this.$store.dispatch({
        type: "agencyUser/updateUser",
        data: this.agencyUser,
      });
      if (response.success) {
        Vue.$toast.success("Kullanıcı başarılı bir şekilde güncellendi");
        (this.$refs.UserForm as any).reset();
        this.closeDialog();
      } else {
        Vue.$toast.error("Bir sorun oluştu");
      }
    } else {
      this.$swal({
        icon: "error",
        title: "",
        text: "Lütfen zorunlu alanları doldurunuz",
        confirmButtonText: "Tamam",
        showConfirmButton: false,
      });
    }
  }
  async deleteUser(){
    let response = await this.$store.dispatch({
        type: "agencyUser/deleteUser",
        data: this.agencyUser,
      });
      if (response.success) {
        Vue.$toast.success("Kullanıcı başarılı bir şekilde silindi");
        (this.$refs.UserForm as any).reset();
        this.closeDialog();
      } else {
        Vue.$toast.error("Bir sorun oluştu");
      }
  }
  confirmDelete() {
    this.$swal({
      title: "Kullanıcı silmek istediğine emin misin ?",      
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:"İptal",
      confirmButtonText: "Sil",
    }).then((result) => {
      if (result.isConfirmed) {
       this.deleteUser();
      }
    });
  }
  async resetPassword(){
    if ((this.$refs.UserForm as any).validate()) {
      let request : any = {};
      request.id= this.agencyUser.id;
      request.password = this.agencyUser.password;      
      let response = await this.$store.dispatch({
        type: "agencyUser/resetUserPassword",
        data:request,
      });
      if (response.success) {
        Vue.$toast.success("Kullanıcı şifresi başarılı bir şekilde güncellendi");
        (this.$refs.UserForm as any).reset();
        this.closeDialog();
      } else {
        Vue.$toast.error("Bir sorun oluştu");
      }
    } else {
      this.$swal({
        icon: "error",
        title: "",
        text: "Lütfen zorunlu alanları doldurunuz",
        confirmButtonText: "Tamam",
        showConfirmButton: false,
      });
    }
  }
  closeDialog() {
    this.$emit("closed");
  }

  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });

    this.agencies = this.$store.state.agency.list;
  }


  created() {
    this.getAgency();
    if (this.modalOpenType !== 0) {
      this.agency=this.selectedUser.agency;
      this.agencyUser.id = this.selectedUser.id;
      this.agencyUser.name = this.selectedUser.name;
      this.agencyUser.surname = this.selectedUser.surname;
      this.agencyUser.userName = this.selectedUser.userName;
      this.agencyUser.emailAddress = this.selectedUser.emailAddress;
      this.agencyUser.phoneNumber = this.selectedUser.phoneNumber;
    }
  }
  data() {
    return {};
  }
}
